import axios from 'axios';
import { HOW_IT_WAS_URL } from '../../constants/urls';

const state = {
    howItWas: null,
};

const actions = {
    getHowItWasBlock({ commit }) {
        const host = this.state.context.host;

        axios.get( host + HOW_IT_WAS_URL, { withCredentials: true } )
            .then((result) => {
                const howItWas = result.data.data;

                if (howItWas) {
                    commit('howItWas', result.data.data);
                }
            })
            .catch((error) => {
                /* eslint-disable no-console */
                console.log(error);
            });
    }
};

const getVideoIdYt = (url) => {
    // eslint-disable-next-line
    const p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    return (url.match(p)) ? RegExp.$1 : null;
};

const getVideoIdVk = (url) => {
  const p = /^(?:https?:\/\/)?(?:www\.)?(?:vk\.com|vk\.ru|vkvideo\.ru)\/(?:video(-?\d+)_(\d+))?$/;
  return (url.match(p)) ? { 'oid': RegExp.$1, 'id': RegExp.$2 } : null;
};

const mutations = {
    howItWas(state, value) {
        state.howItWas = value;
        let videoUrl = value.videoUrl;
        state.howItWas.videoIdYt = getVideoIdYt(videoUrl);
        state.howItWas.videoIdVk = getVideoIdVk(videoUrl);
    }
};

const getters = {
    howItWas({ howItWas }) {
        return howItWas;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/about.js